import { useState, useEffect, useRef, useMemo } from 'react';
import { ChoroplethMap } from '../../models/charts/ChoroplethMap';
import { BarChart } from '../../models/charts/BarChart';
import { ApacheEchart } from '../../components/ApacheEchart';
import { PieChart } from '../../models/charts/PieChart';
import { KPIChart } from '../../models/charts/KPIChart';
import { MonitoreoService } from '../../service/monitoreo/MonitoreoService';
import { Generico } from '../../components/Generico';
import { useToken } from "../../components/useToken";
import { Toast } from "primereact/toast";
import { Skeleton } from 'primereact/skeleton';
import { Sidebar } from 'primereact/sidebar';
import { Column } from 'primereact/column';
import { getMonitoreoDashboardTemplate } from '../templates/pdf/MonitoreoDashboardTemplate';
import { Button } from 'primereact/button';
import { useLazyParams } from '../../hooks/useLazyParams';
import { TablaDinamica } from '../../components/TablaDinamica';
import { ClienteAlerta } from '../../models/monitoreo/ClienteAlerta';
import { MonitoreoAlerta as MonitoreoAlertaModel } from '../../models/monitoreo/MonitoreoAlerta';
import { Analista as MonitoreoAnalistaModel } from '../../models/monitoreo/Analista';
import { Card } from 'primereact/card';
import { Menu } from 'primereact/menu';
import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Calendar } from 'primereact/calendar';
import { TabPanel, TabView } from 'primereact/tabview';
import '../../components/estilo.css';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { useFilters } from '../../hooks/useFilters';
import { FilterMatchMode } from 'primereact/api';
import { FiltroAutocomplete, FiltroCatalogoFijo, FiltroRangoNumerico, FiltroUnicoAutocomplete, FiltroUnicoCatalogoFijo } from '../../components/ui/FiltrosGlobales';
import { useCatalogos } from '../../context/CatalogosContext';
import { motion, AnimatePresence } from 'framer-motion';
import { Tag } from 'primereact/tag';
pdfMake.addVirtualFileSystem(pdfFonts);

const monitoreoService = new MonitoreoService();

const URL_CATALOGOS_MODULO = 'dashboard/catalogos/iniciar-catalogos/monitoreo';

const CATALOGOS = [
    'MATRICES',
    'NIVELES_RIESGO_MONITOREO',
    'NIVELES_ALERTA_MONITOREO',
    'JUSTIFICACION_MONITOREO',
    'INSTRUMENTO_MONETARIO_MONITOREO',
    'NIVELES_SUPERA_MONITOREO'
];

export const MonitoreoDashboard = () => {
    const { iniciarCatalogos } = useCatalogos();
    const [catalogos, setCatalogos] = useState({});
    const [kpiSidebar, setKpiSidebar] = useState({ visible: false, tipo: null, title: '' });
    const AlertaModel = useMemo(() => new MonitoreoAlertaModel(), []);
    const tablaEstadoAlerta = useLazyParams({ modelo: AlertaModel.model });
    const funcionAsignarRef = useRef(null);
    const AnalistaModel = useMemo(() => new MonitoreoAnalistaModel(funcionAsignarRef), []);
    const tablaEstadoAnalista = useLazyParams({ modelo: AnalistaModel.model });
    const tablaEstado = useLazyParams({ initialSortField: 'total_alertas', initialSortOrder: -1, modelo: ClienteAlerta });
    const toast = useRef(null);
    const { getRol } = useToken();
    const rol = getRol();
    const [esAdmin, setEsAdmin] = useState(false);
    const [empresasUsuario, setEmpresasUsuario] = useState([]);
    const [empresaSel, setEmpresaSel] = useState(null);
    const [matrizSel, setMatrizSel] = useState(null); // Singular (un solo objeto seleccionado)
    const [catalogosListos, setCatalogosListos] = useState(false);
    const contextoListo = Boolean(empresaSel?.value && matrizSel?.value);
    const [filtrosVisibles, setFiltrosVisibles] = useState(false);
    const { fechasDiferenciaEnDias, getMinMaxValue, funcSistemaError } = Generico();
    const [tabActiveIndex, setTabActiveIndex] = useState(0);
    const [loadingPdf, setLoadingPdf] = useState(false);

    // Control de fechas
    const hoy = new Date();
    const primerDiaAnio = new Date(hoy.getFullYear(), 0, 1);
    const [rangoMaxDias, setRangoMaxDias] = useState(null);

    // Estados para controlar qué tipo de dato mostrar
    const [vistaMapaActual, setVistaMapaActual] = useState('provincia'); // 'provincia' o 'canton'
    const [vistaBarraActual, setVistaBarraActual] = useState('provincia'); // 'provincia' o 'canton'
    // Para las capturas del gráfico
    const chartsRefs = useRef({});
    const setChartRef = (key) => (element) => {
        if (element) {
            chartsRefs.current[key] = element;
        } else {
            // Si el componente se desmonta, limpiamos la referencia
            delete chartsRefs.current[key];
        }
    };

    // Gestión de alertas
    const [dialogAsignar, setDialogAsignar] = useState(false);
    const [filaAlertaSeleccionada, setFilaAlertaSeleccionada] = useState(null);
    const menuRef = useRef(null);
    // Control del Reporte
    const [cargaInicialAlerta, setCargaInicialAlerta] = useState(true); // Bandera para la primera petición
    const [dialogReporte, setDialogReporte] = useState(false);
    const generic = Generico();
    const [fechaInicioReporte, setFechaInicioReporte] = useState(null);
    const [fechaFinReporte, setFechaFinReporte] = useState(null);
    const [tipoReporte, setTipoReporte] = useState('');
    const [loadPdf, setLoadPdf] = useState(false);
    const [loadExcel, setLoadExcel] = useState(false);
    const [diasMaxDescargaReporte, setDiasMaxDescargaReporte] = useState(null); // Se llena desde el back
    // Manejo dinámico de filtros
    const containerRef = useRef(null);
    const [maxFiltrosTop, setMaxFiltrosTop] = useState(4);

    // Contexto Inicial
    useEffect(() => {
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            return;
        }
        monitoreoService.consultarInfo('dashboard/contexto/inicial', { rol }).then((res) => {
            const data = res.data;
            setEsAdmin(data.esAdmin);
            if (!data.esAdmin) {
                setEmpresasUsuario(data.empresas);
                if (data.empresas.length === 1) {
                    setEmpresaSel(data.empresas[0]);
                }
            }
            if (data.configuracion && data.configuracion.dias_max_ver_dashboard) {
                const maxDiasDatos = data.configuracion.dias_max_ver_dashboard;
                setRangoMaxDias(maxDiasDatos);
                const diffDays = fechasDiferenciaEnDias(primerDiaAnio, hoy);
                if (diffDays > maxDiasDatos) {
                    const nuevaFechaInicio = new Date(hoy);
                    nuevaFechaInicio.setDate(hoy.getDate() - maxDiasDatos);
                    cambiarMultiplesFiltros({
                        fecha_inicio: nuevaFechaInicio
                    });
                }
            }
        }).catch((error) => {
            funcSistemaError(error, toast);
        }).finally(() => {

        });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (empresaSel && empresaSel.value) {
            setMatrizSel(null);
            setCatalogosListos(false);
            const params = { empresa_id: empresaSel.value };
            // Aquí se descarga catalogos.MATRICES
            iniciarCatalogos(URL_CATALOGOS_MODULO, CATALOGOS, params, true).then((res) => {
                setCatalogos(res.data);
                setCatalogosListos(true);
                if (res.data.MATRICES && res.data.MATRICES.length > 0) {
                    setMatrizSel(res.data.MATRICES[0]);
                }
            }).catch((error) => funcSistemaError(error, toast));
        } else {
            setMatrizSel(null);
            setCatalogosListos(false);
        }
        // eslint-disable-next-line
    }, [empresaSel?.value]);

    const fetchDashboardData = (payload) => {
        const params = {
            rol: rol,
            empresa_id: empresaSel?.value,
            matriz_id: matrizSel?.value,
            filters: JSON.stringify(payload)
        };
        return monitoreoService.consultarInfo('dashboard/listar/monitoreo', params).then(res => {
            return res.data; // Asegúrate de retornar la data
        }).catch((error) => {
            funcSistemaError(error, toast);
            return [];
        });
    };

    const { filtros, obtenerPayloadBackend, cambiarFiltro, cambiarMultiplesFiltros, totalFiltrosActivos, recargar, resetearFiltros, data, loading } = useFilters(
        {
            nombres: { value: [], matchMode: FilterMatchMode.IN },
            identificacion: { value: [], matchMode: FilterMatchMode.IN },
            // Rangos numéricos
            ingreso_mensual_neto_min: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
            ingreso_mensual_neto_max: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
            numero_transacciones_min: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
            numero_transacciones_max: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
            total_transaccion_min: { value: null, matchMode: FilterMatchMode.GREATER_THAN_OR_EQUAL_TO },
            total_transaccion_max: { value: null, matchMode: FilterMatchMode.LESS_THAN_OR_EQUAL_TO },
            // Niveles de Riesgo y Alertas
            nivel_de_riesgo: { value: [], matchMode: FilterMatchMode.IN },
            alerta_temprana: { value: [], matchMode: FilterMatchMode.IN },
            alerta_transacciones: { value: [], matchMode: FilterMatchMode.IN },
            supera_umbral: { value: [], matchMode: FilterMatchMode.IN },
            tipo_medio_pago: { value: [], matchMode: FilterMatchMode.IN },
            alerta_medio_pago: { value: [], matchMode: FilterMatchMode.IN },
            nivel_mayor_alerta: { value: [], matchMode: FilterMatchMode.IN },
            justificacion: { value: [], matchMode: FilterMatchMode.IN },
        }, fetchDashboardData, 600, contextoListo);

    useEffect(() => {
        if (contextoListo && catalogosListos) {
            recargar();
        }
        // eslint-disable-next-line
    }, [matrizSel]);

    const opcionesMatrices = catalogos.MATRICES || [];
    const opcionesNivelRiesgo = catalogos.NIVELES_RIESGO_MONITOREO || [];
    const opcionesAlerta = catalogos.NIVELES_ALERTA_MONITOREO || [];
    const opcionesJustificacion = catalogos.JUSTIFICACION_MONITOREO || [];
    const opcionesInstrumentoMonetario = catalogos.INSTRUMENTO_MONETARIO_MONITOREO || [];
    const opcionesSupera = catalogos.NIVELES_SUPERA_MONITOREO || [];

    // Catalogos autocomplete
    const fetchCatalogo = (tipo) => (texto = '') => {
        const params = { texto: texto, empresa_id: empresaSel.value, matriz_id: matrizSel.value }
        return monitoreoService.consultarInfo(`dashboard/catalogos/autocomplete/monitoreo/${tipo}`, params).then((res) => {
            return res.data
        }).catch((error) => {
            funcSistemaError(error, toast);
            return [];
        }).finally(() => {

        });
    };

    const buscarSugerenciasEmpresa = (texto) => {
        return monitoreoService.consultarInfo('dashboard/contexto/empresas-buscar', { texto }).then((res) => {
            return res.data
        }).catch((error) => {
            funcSistemaError(error, toast);
            return [];
        }).finally(() => {

        });
    };

    const todosLosFiltros = [
        {
            id: 'empresa',
            label: 'Empresa *',
            show: esAdmin || !empresasUsuario || empresasUsuario.length !== 1,
            pinnedTop: true,
            componente: esAdmin ? (
                <FiltroUnicoAutocomplete id="filtro-empresa-sa" value={empresaSel} onChange={setEmpresaSel} fetchData={buscarSugerenciasEmpresa} placeholder="Buscar empresa..." />
            ) : (
                <FiltroUnicoCatalogoFijo value={empresaSel?.value} options={empresasUsuario} onChange={(val) => { const selected = empresasUsuario.find(e => e.value === val); setEmpresaSel(selected || null); }} placeholder="Seleccione Empresa" icon="pi pi-building" />
            )
        },
        {
            id: 'matriz',
            label: 'Matriz de Monitoreo *',
            show: true,
            pinnedTop: true,
            componente: !catalogosListos ? <Skeleton height="32.2px" /> : (
                <FiltroUnicoAutocomplete id="filtro-matriz" value={matrizSel} onChange={(val) => setMatrizSel(val)} fetchData={fetchCatalogo('MATRICES')} opcionesLocales={opcionesMatrices} placeholder={empresaSel ? "Buscar por nombre o código..." : "Seleccione Empresa primero"} disabled={!empresaSel || !catalogosListos} icon="pi pi-table" dropdown={true} />
            )
        },
        {
            id: 'nombres',
            label: 'Nombre / Razón Social',
            show: true,
            pinnedTop: true,
            componente: !contextoListo ? <Skeleton height="32.2px" /> : <FiltroAutocomplete value={filtros.nombres.value} onChange={(val) => cambiarFiltro('nombres', val)} fetchData={fetchCatalogo('NOMBRES')} tooltipPosition="left" icon="pi pi-user" />
        },
        {
            id: 'identificacion',
            label: 'Identificación',
            show: true,
            componente: !contextoListo ? <Skeleton height="32.2px" /> : <FiltroAutocomplete value={filtros.identificacion.value} onChange={(val) => cambiarFiltro('identificacion', val)} fetchData={fetchCatalogo('IDENTIFICACION')} tooltipPosition="left" icon="pi pi-id-card" />
        },
        {
            id: 'ingreso_mensual_neto',
            label: 'Ingreso Mensual Neto',
            show: true,
            componente: <FiltroRangoNumerico valueMin={filtros.ingreso_mensual_neto_min.value} valueMax={filtros.ingreso_mensual_neto_max.value} onChange={({ min, max }) => cambiarMultiplesFiltros({ ingreso_mensual_neto_min: min, ingreso_mensual_neto_max: max })} />
        },
        {
            id: 'numero_transacciones',
            label: 'N° de Transacciones',
            show: true,
            componente: <FiltroRangoNumerico isCurrency={false} icon="pi pi-hashtag" minProps={{ minFractionDigits: 0 }} maxProps={{ minFractionDigits: 0 }} valueMin={filtros.numero_transacciones_min.value} valueMax={filtros.numero_transacciones_max.value} onChange={({ min, max }) => cambiarMultiplesFiltros({ numero_transacciones_min: min, numero_transacciones_max: max })} />
        },
        {
            id: 'total_transaccion',
            label: 'Total Transacciones',
            show: true,
            componente: <FiltroRangoNumerico valueMin={filtros.total_transaccion_min.value} valueMax={filtros.total_transaccion_max.value} onChange={({ min, max }) => cambiarMultiplesFiltros({ total_transaccion_min: min, total_transaccion_max: max })} />
        },
        {
            id: 'nivel_de_riesgo',
            label: 'Riesgo por Desviación de Perfil Económico',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.nivel_de_riesgo.value} onChange={(val) => cambiarFiltro('nivel_de_riesgo', val)} options={opcionesNivelRiesgo} placeholder="Seleccione Riesgos" icon="pi pi-shield" />
        },
        {
            id: 'alerta_temprana',
            label: 'Alerta Temprana',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.alerta_temprana.value} onChange={(val) => cambiarFiltro('alerta_temprana', val)} options={opcionesAlerta} placeholder="Seleccionar..." icon="pi pi-bell" />
        },
        {
            id: 'alerta_transacciones',
            label: 'Alerta N° de Transacciones',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.alerta_transacciones.value} onChange={(val) => cambiarFiltro('alerta_transacciones', val)} options={opcionesNivelRiesgo} placeholder="Seleccionar..." icon="pi pi-exclamation-triangle" />
        },
        {
            id: 'supera_umbral',
            label: 'Transacciones Superan el Umbral',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.supera_umbral.value} onChange={(val) => cambiarFiltro('supera_umbral', val)} options={opcionesSupera} placeholder="Seleccionar..." icon="pi pi-dollar" />
        },
        {
            id: 'tipo_medio_pago',
            label: 'Medio de Pago',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.tipo_medio_pago.value} onChange={(val) => cambiarFiltro('tipo_medio_pago', val)} options={opcionesInstrumentoMonetario} placeholder="Seleccione Medios" icon="pi pi-wallet" />
        },
        {
            id: 'alerta_medio_pago',
            label: 'Alerta Medio de Pago',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.alerta_medio_pago.value} onChange={(val) => cambiarFiltro('alerta_medio_pago', val)} options={opcionesNivelRiesgo} placeholder="Seleccionar..." icon="pi pi-credit-card" />
        },
        {
            id: 'nivel_mayor_alerta',
            label: 'Nivel Mayor Alerta',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.nivel_mayor_alerta.value} onChange={(val) => cambiarFiltro('nivel_mayor_alerta', val)} options={opcionesNivelRiesgo} placeholder="Seleccione Niveles" icon="pi pi-angle-double-up" />
        },
        {
            id: 'justificacion',
            label: 'Estado de Justificación',
            show: true,
            componente: <FiltroCatalogoFijo value={filtros.justificacion.value} onChange={(val) => cambiarFiltro('justificacion', val)} options={opcionesJustificacion} placeholder="Seleccione Estado" icon="pi pi-check-square" />
        },
    ];

    useEffect(() => {
        if (!containerRef.current) return;
        const observer = new ResizeObserver((entries) => {
            const containerWidth = entries[0].contentRect.width;
            const ANCHO_BASE_FILTRO = 250; // Tamaño estimado para el calculo de cuantos caben.
            const GAP = 16;
            const cantidadCalculada = Math.floor((containerWidth + GAP) / (ANCHO_BASE_FILTRO + GAP));
            setMaxFiltrosTop(cantidadCalculada > 0 ? cantidadCalculada : 1);
        });
        observer.observe(containerRef.current);
        return () => observer.disconnect();
    }, []);

    // DIVIDIR LOS FILTROS ACTIVOS (Los primeros X van arriba, el resto al Sidebar)
    const filtrosActivos = todosLosFiltros.filter(f => f.show);
    const filtrosTop = [];
    const filtrosSidebar = [];
    let contadorTop = 0;
    filtrosActivos.forEach(filtro => {
        if (filtro.pinnedTop || contadorTop < maxFiltrosTop) {
            filtrosTop.push(filtro);
            contadorTop++;
        } else {
            filtrosSidebar.push(filtro);
        }
    });

    const ejecutarGestionarAnalista = (analista, esRemover) => {
        const payload = { alerta_id: filaAlertaSeleccionada.id, analista_id: analista.id, remover: esRemover };
        tablaEstadoAnalista.setLoading(true);
        monitoreoService.editar(payload, 'monitoreo/alerta/gestionar-analista').then((res) => {
            const msg = esRemover ? `Analista ${analista.nombre} desasignado. Alerta ahora VISUALIZADA.` : `Analista ${analista.nombre} asignado correctamente.`
            toast.current.show({ severity: 'success', summary: 'Operación Exitosa', detail: msg });
            tablaEstadoAlerta.refreshData(); // Solo si la asignación fue exitosa, recargar la tabla de alertas
        }).catch((error) => {
            const msg = error.response?.data?.message || 'Error en la operación';
            toast.current.show({ severity: 'error', summary: 'Error', detail: msg });
        }).finally(() => {
            tablaEstadoAnalista.refreshData(); // Esto llama a loadLazyData que a su vez desactiva el loading
        });
    };

    const gestionarAsignacion = (analista) => {
        if (!filaAlertaSeleccionada?.id) {
            toast.current.show({ severity: 'warn', summary: 'Atención', detail: 'Selecciona una alerta primero.' });
            return;
        }

        // Validación de estados bloqueados
        const estadosBloqueados = ['ESTADO_ALERTA_FALSO_POSITIVO', 'ESTADO_ALERTA_MATRIZ_FINALIZADA', 'ESTADO_ALERTA_EN_MATRIZ'];
        if (estadosBloqueados.includes(filaAlertaSeleccionada.estado_nemonico)) {
            toast.current.show({ severity: 'error', summary: 'Acción Denegada', detail: `No se puede modificar una alerta en estado: ${filaAlertaSeleccionada.estado_nombre}.` });
            return;
        }

        const esRemover = analista.es_asignado === true; // Si detecta que esta asignado, la opción será removerlo
        let headerDialog, mensajeDialog, iconDialog, btnClass;

        if (esRemover) {
            headerDialog = 'Confirmar Desasignación';
            iconDialog = 'pi pi-user-minus';
            btnClass = 'p-button-danger';
            mensajeDialog = (
                <div>
                    <p>¿Está seguro de quitar al analista <strong>{analista.nombre}</strong> de esta alerta?</p>
                    <p className="text-sm text-500">La alerta pasará a estado <strong>VISUALIZADA</strong> y quedará sin responsable.</p>
                </div>
            );
        } else {
            headerDialog = 'Confirmar Asignación';
            iconDialog = 'pi pi-user-plus';
            btnClass = 'p-button-primary';

            if (filaAlertaSeleccionada.usuario_asignado_nombre) {
                // Si ya tiene otro asignado (Reasignación)
                mensajeDialog = (
                    <div>
                        <p>La alerta actualmente pertenece a: <strong>{filaAlertaSeleccionada.usuario_asignado_nombre}</strong>.</p>
                        <p>¿Desea transferir la responsabilidad a <strong>{analista.nombre}</strong>?</p>
                    </div>
                );
            } else {
                // Asignación limpia
                mensajeDialog = (
                    <span>¿Asignar la alerta al analista <strong>{analista.nombre}</strong>?</span>
                );
            }
        }

        confirmDialog({
            message: mensajeDialog,
            header: headerDialog,
            icon: iconDialog,
            acceptLabel: esRemover ? 'Sí, Quitar' : 'Sí, Asignar',
            rejectLabel: 'Cancelar',
            acceptClassName: btnClass,
            accept: () => ejecutarGestionarAnalista(analista, esRemover)
        });
    };

    funcionAsignarRef.current = gestionarAsignacion;

    const abrirModalAsignacion = () => {
        if (!filaAlertaSeleccionada) {
            return;
        }
        const estadosBloqueados = ['ESTADO_ALERTA_FALSO_POSITIVO', 'ESTADO_ALERTA_MATRIZ_FINALIZADA', 'ESTADO_ALERTA_EN_MATRIZ'];
        if (estadosBloqueados.includes(filaAlertaSeleccionada.estado_nemonico)) {
            toast.current.show({ severity: 'warn', summary: 'Acción no permitida', detail: `No se puede gestionar analistas porque la alerta está en estado: ${filaAlertaSeleccionada.estado_nombre}.` });
            return;
        }
        setDialogAsignar(true);
    };

    // Información de las alertas
    const loadLazyDataAlertas = () => {
        tablaEstadoAlerta.setLoading(true);
        const params = {
            lazyEvent: JSON.stringify({
                ...tablaEstadoAlerta.lazyParams,
                rol: getRol(),
                carga_inicial_alerta: cargaInicialAlerta === true ? true : null
            })
        };
        monitoreoService.consultarInfo('monitoreo/alerta/lista', params).then(res => {
            tablaEstadoAlerta.setData(res.data.registros || []);
            tablaEstadoAlerta.setTotalRecords(res.data.total || 0);
            if (res.data.dias_max_descarga_reporte !== undefined) {
                setDiasMaxDescargaReporte(res.data.dias_max_descarga_reporte);
                setCargaInicialAlerta(false);
            }
        }).catch((error) => {

        }).finally(() => {
            tablaEstadoAlerta.setLoading(false);
        });
    };

    // Información de los analistas
    const loadLazyDataAnalistas = () => {
        tablaEstadoAnalista.setLoading(true);
        const params = {
            lazyEvent: JSON.stringify({
                ...tablaEstadoAnalista.lazyParams,
                rol: getRol()
            }),
            alerta_id: filaAlertaSeleccionada.id
        };
        monitoreoService.consultarInfo('monitoreo/alerta/listar-analistas', params).then(res => {
            tablaEstadoAnalista.setData(res.data.registros || []);
            tablaEstadoAnalista.setTotalRecords(res.data.total || 0);
        }).catch((error) => {

        }).finally(() => {
            tablaEstadoAnalista.setLoading(false);
        });
    };

    const itemsMenu = [
        {
            label: 'Distribución',
            items: [
                {
                    label: 'Asignar analista',
                    icon: 'pi pi-users',
                    command: () => {
                        abrirModalAsignacion();
                    }
                }
            ]
        },
    ];

    const accionesBodyTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones" aria-controls="popup_menu_alertas" aria-haspopup
                onClick={(event) => { setFilaAlertaSeleccionada(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const columnaAcciones = (
        <Column header="Acciones" body={accionesBodyTemplate} style={{ width: '6rem', textAlign: 'center' }} alignFrozen="right" />
    );

    useEffect(() => {
        if (!kpiSidebar.visible || !kpiSidebar.tipo) return;
        tablaEstado.setLoading(true);
        const params = {
            ...tablaEstado.lazyParams,
            rol: rol,
            empresa_id: empresaSel?.value,
            matriz_id: matrizSel?.value,
            dashboard_filters: obtenerPayloadBackend(),
            kpi_tipo: kpiSidebar.tipo
        };

        monitoreoService.consultarInfo('dashboard/detalle/monitoreo/clientes-alertas', params).then(res => {
            tablaEstado.setData(res.data.registros);
            tablaEstado.setTotalRecords(res.data.total);
        }).catch(error => {
            funcSistemaError(error, toast);
            tablaEstado.setData([]);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });

        // eslint-disable-next-line
    }, [tablaEstado.lazyParams, kpiSidebar.visible, kpiSidebar.tipo]);

    useEffect(() => {
        loadLazyDataAlertas();
    }, [tablaEstadoAlerta.lazyParams]);

    useEffect(() => {
        if (dialogAsignar) {
            loadLazyDataAnalistas();
        }
    }, [tablaEstadoAnalista.lazyParams, dialogAsignar]);

    const generarReporte = (tipo) => {
        if (!fechaInicioReporte || !fechaFinReporte) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Seleccione el rango de fechas', life: 6000 });
            return;
        } else if (fechaInicioReporte > fechaFinReporte) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'La fecha de inicio debe ser menor a la fecha de fin', life: 6000 });
            return;
        } else if (generic.fechasDiferenciaEnDias(fechaInicioReporte, fechaFinReporte) > diasMaxDescargaReporte) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: `El rango de fechas no puede superar los ${diasMaxDescargaReporte} días`, life: 6000 });
            return;
        }
        const _inicio = generic.dateToString(fechaInicioReporte);
        const _fin = generic.dateToString(fechaFinReporte);
        if (tipo === 'pdf') {
            setLoadPdf(true);
        }
        if (tipo === 'xlsx') {
            setLoadExcel(true);
        }
        const params = { rol: getRol() };
        const url = `monitoreo/alerta/reporte/${tipo}/${_inicio}/${_fin}`;
        const hoyFormateado = new Date().toISOString().split('T')[0];
        if (tipo === 'xlsx') {
            monitoreoService.generarDocumento(url, params).then(res => {
                generic.downloadPdf(res.data, `Reporte_Alertas_${hoyFormateado}.xlsx`);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Reporte Excel descargado correctamente', life: 3000 });
                setDialogReporte(false);
                limpiarReporte();
            }).catch((err) => {
                generic.funcSistemaError(err, toast);
            }).finally(() => {
                setLoadExcel(false);
            });

        } else {
            monitoreoService.consultarInfo(url, params).then(res => {
                const { info, detalle } = res.data;
                const docDefinition = MonitoreoAlertaModel.getReportTemplate(detalle, info);
                pdfMake.createPdf(docDefinition).download(`Reporte_Alertas_${hoyFormateado}.pdf`);
                toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Reporte PDF generado correctamente', life: 3000 });
                setDialogReporte(false);
                limpiarReporte();
            }).catch((err) => {
                generic.funcSistemaError(err, toast);
            }).finally(() => {
                setLoadPdf(false);
            });
        }
    };

    const limpiarReporte = () => {
        setFechaInicioReporte(null);
        setFechaFinReporte(null);
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };

    const kpiPrincipal = useMemo(() => {
        const kpisComportamiento = data?.seccion_comportamiento_perfil_transaccional?.primera_fila_kpi || {};
        const clientesAlertas = kpisComportamiento.clientes_con_alertas || {};
        const clientesRevisados = kpisComportamiento.clientes_revisados || {};
        const desviacionPerfil = kpisComportamiento.desviacion_perfil_economico || 0;
        const excesoTransacciones = kpisComportamiento.exceso_transacciones || 0;
        const mediosPago = kpisComportamiento.medio_de_pago || 0;
        const porcentajeRevisados = clientesRevisados.porcentaje || 0;
        const colorRevisados = porcentajeRevisados < 80 ? '#ef4444' : '#10b981';

        return [
            {
                tipo: 'detalle_clientes_alertas',
                title: 'Clientes con alertas',
                color: '#EB0000',
                options: new KPIChart({
                    value: clientesAlertas.valor || 0,
                    kpiTitle: 'Clientes con alertas',
                    unit: ' alertas',
                    themeColor: '#EB0000',
                    valueColor: '#EB0000',
                    icon: 'pi pi-user-edit',
                    layout: 'modern',
                    bottomRightInfo: {
                        text: clientesAlertas.subtexto || 'Sin datos',
                        icon: 'pi pi-users'
                    }
                }).getOptions()
            },
            {
                tipo: 'detalle_clientes_revisados',
                title: 'Clientes revisados',
                color: colorRevisados,
                options: new KPIChart({
                    value: `${porcentajeRevisados}%`,
                    kpiTitle: 'Clientes revisados',
                    themeColor: colorRevisados,
                    valueColor: colorRevisados,
                    icon: 'pi pi-check-square',
                    layout: 'modern',
                    bottomRightInfo: {
                        text: `${clientesRevisados.subtexto_izq || '0'} | ${clientesRevisados.subtexto_der || '0'}`,
                    }
                }).getOptions()
            },
            {
                tipo: 'detalle_desviacion_perfil',
                title: 'Desviación Perfil Económico',
                color: '#9333ea',
                options: new KPIChart({
                    value: desviacionPerfil,
                    kpiTitle: 'Desviación Perfil Económico',
                    unit: ' alertas',
                    themeColor: '#9333ea',
                    valueColor: '#9333ea',
                    icon: 'pi pi-chart-line',
                    layout: 'modern',
                }).getOptions()
            },
            {
                tipo: 'detalle_exceso_transacciones',
                title: 'Exceso de Transacciones',
                color: '#0ea5e9',
                options: new KPIChart({
                    value: excesoTransacciones,
                    kpiTitle: 'Exceso de Transacciones',
                    unit: ' alertas',
                    themeColor: '#0ea5e9',
                    valueColor: '#0ea5e9',
                    icon: 'pi pi-list',
                    layout: 'modern',
                }).getOptions()
            },
            {
                tipo: 'detalle_medios_pago',
                title: 'Medios de Pago',
                color: '#f59e0b',
                options: new KPIChart({
                    value: mediosPago,
                    kpiTitle: 'Medios de Pago',
                    unit: ' alertas',
                    themeColor: '#f59e0b',
                    valueColor: '#f59e0b',
                    icon: 'pi pi-credit-card',
                    layout: 'modern',
                    bottomRightInfo: {
                        text: 'Instrumentos de alto riesgo',
                    }
                }).getOptions()
            }
        ];
    }, [data]);

    const kpiDemografico = useMemo(() => {
        const kpisGeo = data?.seccion_comportamiento_perfil_transaccional?.segunda_fila_kpi || {};
        const volumen = kpisGeo.volumen_total || {};
        const alcance = kpisGeo.alcance_geografico || {};
        const maxProvincia = kpisGeo.provincia_mayor_concentracion || {};
        return [
            {
                tipo: 'detalle_volumen',
                title: 'Volumen total',
                color: '#059669',
                options: new KPIChart({
                    value: formatCurrency(volumen.valor || 0),
                    kpiTitle: 'Volumen total',
                    themeColor: '#059669',
                    valueColor: '#059669',
                    icon: 'pi pi-money-bill',
                    layout: 'modern',
                    bottomRightInfo: {
                        text: volumen.subtexto_der || 'Transacciones: 0',
                        icon: 'pi pi-tag'
                    }
                }).getOptions()
            },
            {
                tipo: 'detalle_alcance_geo',
                title: 'Alcance geográfico',
                color: '#0891b2',
                options: new KPIChart({
                    value: alcance.provincias || 0,
                    kpiTitle: 'Alcance Geográfico',
                    unit: ' provincias',
                    themeColor: '#0891b2',
                    valueColor: '#0891b2',
                    icon: 'pi pi-map',
                    layout: 'modern',
                    bottomRightInfo: {
                        text: `${alcance.cantones || 0} cantones cubiertos`,
                        icon: 'pi pi-globe'
                    }
                }).getOptions()
            },
            {
                tipo: 'detalle_mayor_concentracion',
                title: 'Provincia mayor concentración',
                color: '#4f46e5',
                options: new KPIChart({
                    value: maxProvincia.nombre || 'N/A',
                    kpiTitle: 'Con mayor concentración',
                    subtext: `${maxProvincia.valor} clientes`,
                    themeColor: '#4f46e5',
                    valueColor: '#4f46e5',
                    icon: 'pi pi-building',
                    layout: 'modern',
                }).getOptions()
            }
        ];
    }, [data]);

    // useEffect unificado para MAPAS
    const mapChartOptions = useMemo(() => {
        const indicadores = data?.seccion_indicadores || {};
        const esProvincia = vistaMapaActual === 'provincia';
        const mapDataObj = esProvincia ? indicadores.provincias_clientes : indicadores.cantones_clientes;
        const chartData = mapDataObj?.data || [];
        let finalMin = 0;
        let finalMax = 10;
        if (chartData.length > 0) {
            const { min, max } = getMinMaxValue(chartData);
            finalMin = min;
            finalMax = max;
        }
        const nivelTexto = esProvincia ? 'Provincia' : 'Cantón';
        return new ChoroplethMap({
            data: chartData,
            mapType: esProvincia ? 'Ecuador' : 'CantonesEcuador',
            nameProperty: esProvincia ? 'NEMONICO' : 'PCODE2',
            seriesId: `mapa-clientes-${vistaMapaActual}-ecuador`,
            universalTransition: false,
            title: `Clientes por ${nivelTexto} - Ecuador`,
            subtitle: `Distribución de clientes por ${vistaMapaActual}`,
            titlePosition: 'center',
            visualMapMin: finalMin,
            visualMapMax: finalMax,
            visualMapLeft: 'left',
            visualMapTop: 'bottom',
            visualMapText: ['Mayor cantidad', 'Menor cantidad'],
            colorRange: ['#e6e6e6', '#667eea'],
            defaultBorderColor: '#37474f',
            hoverColor: '#42a5f5',
            selectionColor: '#1565c0',
            selectionBorderColor: '#fff',
            selectionBorderWidth: 2,
            selectedMode: 'single',
            roam: true,
            scaleLimit: esProvincia ? { min: 0.8, max: 4 } : { min: 1, max: 6 },
            showLabels: false,
            emphasis: {
                focus: 'series',
                label: { show: true, fontSize: 11, fontWeight: 'bold', color: '#000' },
            },
            animationDuration: 1500,
            animationEasing: 'elasticOut',
            tooltipFormatter: (params) => {
                const nombre = params.data?.labelName || params.name;
                const valor = (typeof params.value === 'number' && !isNaN(params.value)) ? params.value.toLocaleString() : '0';
                return `
                    <div style="padding: 10px; min-width: 180px;">
                        <strong style="font-size: 15px; color: #e6e6e6;">${nombre}</strong><br/>
                        <div style="margin-top: 6px; line-height: 1.8;">
                            <span style="color: #ccc;">Cantidad de clientes:</span> <strong>${valor}</strong>
                        </div>
                    </div>`;
            },
            customToolboxButtons: [
                {
                    name: 'myCambiarVista',
                    title: esProvincia ? 'Vista por cantones' : 'Vista por provincias',
                    icon: 'path://M114.279,0v114.274H0v378.034h378.039V378.029h114.269V0H114.279z M358.346,472.615H19.692V133.966h338.654V472.615z M472.615,358.337h-94.577V114.274H133.971V19.692h338.644V358.337z',
                    onclick: function () {
                        setVistaMapaActual(esProvincia ? 'canton' : 'provincia');
                    }
                }
            ]
        }).getOptions();
    }, [data, vistaMapaActual]);

    const barChartOptions = useMemo(() => {
        const indicadores = data?.seccion_indicadores || {};
        const esProvincia = vistaBarraActual === 'provincia';
        const barDataObj = esProvincia ? indicadores.bar_provincias_cliente : indicadores.bar_cantones_cliente;
        const chartData = Array.isArray(barDataObj) ? barDataObj : (barDataObj?.data || []);
        const nivelTexto = esProvincia ? 'Provincia' : 'Cantón';
        const nivelPlural = esProvincia ? 'Provincias' : 'Cantones';

        return new BarChart({
            data: chartData,
            seriesId: `bar-${vistaBarraActual}-clientes`,
            title: `Clientes por ${nivelTexto}`,
            subtitle: `${nivelTexto} de residencia de los clientes`,
            orientation: 'horizontal',
            barColor: '#2f353a',
            barBorderRadius: 8,
            barMaxWidth: 40,
            showBackground: true,
            backgroundColor: 'rgba(102, 126, 234, 0.1)',
            yAxisName: nivelPlural,
            xAxisName: 'Cantidad de clientes',
            xAxisNameGap: 35,
            yAxisNameGap: 105,
            showLabels: false,
            labelPosition: 'right',
            labelFontSize: 11,
            labelFontWeight: 'bold',
            emphasis: {
                focus: 'series',
                blurScope: 'coordinateSystem',
            },
            animationDuration: 1200,
            sortAscending: true,
            tooltipFormatter: (params) => {
                const p = Array.isArray(params) ? params[0] : params;
                return `
                    <div style="padding: 10px; min-width: 180px;">
                        <strong style="font-size: 15px; color: #e6e6e6;">${p.name}</strong><br/>
                        <div style="margin-top: 6px; line-height: 1.8;">
                            <span style="color: #ccc;">Cantidad de clientes:</span> <strong>${p.value.toLocaleString()}</strong>
                        </div>
                    </div>`;
            },
            customToolboxButtons: [
                {
                    name: 'myCambiarVista',
                    title: esProvincia ? 'Vista por cantones' : 'Vista por provincias',
                    icon: 'path://M114.279,0v114.274H0v378.034h378.039V378.029h114.269V0H114.279z M358.346,472.615H19.692V133.966h338.654V472.615z M472.615,358.337h-94.577V114.274H133.971V19.692h338.644V358.337z',
                    onclick: function () {
                        setVistaBarraActual(esProvincia ? 'canton' : 'provincia');
                    }
                }
            ]
        }).getOptions();
    }, [data, vistaBarraActual]);

    const pieChartOptions = useMemo(() => {
        const indicadores = data?.seccion_indicadores || {};
        const chartData = indicadores.instrumento_transacciones?.data || [];

        return new PieChart({
            data: chartData,
            seriesId: 'instrumento-transaccion-pie',
            title: 'Distribución de instrumentos de transacción',
            subtitle: 'Tipos de transacción usados',
            radius: '60%',
            center: ['50%', '50%'],
            pieCenter: ['50%', '56%'],
            selectedMode: 'single',
            selectedOffset: 20,
            minAngle: 5,
            labelPosition: 'outside',
            showPercentage: true,
            percentPrecision: 1,
            itemBorderWidth: 3,
            itemBorderRadius: 8,
            colorPalette: [
                '#667eea', '#764ba2', '#f093fb', '#4facfe',
                '#43e97b', '#fa709a', '#fee140', '#30cfd0'
            ],
            animationDuration: 1500,
            animationEasing: 'elasticOut',
        }).transformToDonut().getOptions();
    }, [data]);

    const capturarTodosLosGraficos = () => {
        const capturas = {};
        // Dimensiones exactas calculadas para el Grid del Template A3
        const DIMENSIONES_PDF = {
            // Fila 1: 5 KPIs (Ancho: 210)
            'kpi-riesgo-0': { targetWidth: 210, targetHeight: 110 },
            'kpi-riesgo-1': { targetWidth: 210, targetHeight: 110 },
            'kpi-riesgo-2': { targetWidth: 210, targetHeight: 110 },
            'kpi-riesgo-3': { targetWidth: 210, targetHeight: 110 },
            'kpi-riesgo-4': { targetWidth: 210, targetHeight: 110 },
            // Fila 2: 3 KPIs Demográficos (Ancho: 210)
            'kpi-centrado-0': { targetWidth: 210, targetHeight: 110 },
            'kpi-centrado-1': { targetWidth: 210, targetHeight: 110 },
            'kpi-centrado-2': { targetWidth: 210, targetHeight: 110 },
            // Fila 3: Mapa y Barras (Mitad de pantalla, Ancho: 547)
            'mapa-principal': { targetWidth: 547, targetHeight: 330 },
            'barras-principal': { targetWidth: 547, targetHeight: 330 },
            // Fila 4: Pie Chart (Centrado, Ancho: 547)
            'pie-chart': { targetWidth: 547, targetHeight: 330 }
        };

        Object.keys(chartsRefs.current).forEach((key) => {
            const chartComponent = chartsRefs.current[key];
            if (chartComponent && typeof chartComponent.captureImage === 'function') {
                try {
                    const sizes = DIMENSIONES_PDF[key] || {};
                    const imgBase64 = chartComponent.captureImage({
                        backgroundColor: '#ffffff',
                        ...sizes
                    });
                    if (imgBase64) capturas[key] = imgBase64;
                } catch (error) {
                    console.error('Error al capturar gráfico:', key);
                }
            }
        });
        return capturas;
    };

    const obtenerFiltrosLegibles = () => {
        const filtrosActivos = [];
        const catalogosMap = {
            nivel_de_riesgo: opcionesNivelRiesgo,
            alerta_temprana: opcionesAlerta,
            alerta_transacciones: opcionesNivelRiesgo,
            supera_umbral: opcionesSupera,
            tipo_medio_pago: opcionesInstrumentoMonetario,
            alerta_medio_pago: opcionesNivelRiesgo,
            nivel_mayor_alerta: opcionesNivelRiesgo,
            justificacion: opcionesJustificacion
        };

        const diccionarioTitulos = {
            nombres: 'Nombre / Razón Social',
            identificacion: 'Identificación',
            nivel_de_riesgo: 'Riesgo por Desv. Perfil Económico',
            alerta_temprana: 'Alerta Temprana',
            alerta_transacciones: 'Alerta N° de Transacciones',
            supera_umbral: 'Transacciones Superan Umbral',
            tipo_medio_pago: 'Medio de Pago',
            alerta_medio_pago: 'Alerta Medio de Pago',
            nivel_mayor_alerta: 'Nivel Mayor Alerta',
            justificacion: 'Justificación'
        };

        const extraerTexto = (val, key) => {
            if (Array.isArray(val)) {
                return val.map(v => {
                    // Si el valor ya es un objeto (ej: desde Autocomplete)
                    if (v !== null && typeof v === 'object') return v.label || v.name || v.value;
                    // Si es un ID/Nemónico y existe en nuestro mapa de catálogos
                    if (catalogosMap[key]) {
                        const encontrado = catalogosMap[key].find(opt => String(opt.value) === String(v));
                        return encontrado ? (encontrado.label || encontrado.name) : v;
                    }
                    return v;
                }).join(', ');
            }
            if (val && typeof val === 'object') {
                return val.label || val.name || val.value || '';
            }
            if (catalogosMap[key]) {
                const encontrado = catalogosMap[key].find(opt => String(opt.value) === String(val));
                if (encontrado) return encontrado.label || encontrado.name;
            }
            return String(val);
        };

        // Extraer Listas y Autocompletes
        Object.keys(diccionarioTitulos).forEach(key => {
            const filterObj = filtros[key];
            if (filterObj && filterObj.value) {
                const val = filterObj.value;
                const esArregloVacio = Array.isArray(val) && val.length === 0;
                if (!esArregloVacio && val !== null && val !== '') {
                    // Aquí pasamos el key para que extraerTexto sepa en qué catálogo buscar
                    filtrosActivos.push({ label: diccionarioTitulos[key], value: extraerTexto(val, key), isDefault: false });
                }
            }
        });

        // Extraer Rangos Numéricos
        const rangos = [
            { min: 'ingreso_mensual_neto_min', max: 'ingreso_mensual_neto_max', label: 'Ingreso Mensual Neto', prefijo: '$' },
            { min: 'numero_transacciones_min', max: 'numero_transacciones_max', label: 'N° de Transacciones', prefijo: '' },
            { min: 'total_transaccion_min', max: 'total_transaccion_max', label: 'Total Transacciones', prefijo: '$' }
        ];

        rangos.forEach(rango => {
            const valMin = filtros[rango.min]?.value;
            const valMax = filtros[rango.max]?.value;
            if (valMin !== null || valMax !== null) {
                const min = valMin !== null ? `${rango.prefijo}${valMin}` : '0';
                const max = valMax !== null ? `${rango.prefijo}${valMax}` : 'Sin límite';
                filtrosActivos.push({ label: rango.label, value: `Desde: ${min} - Hasta: ${max}`, isDefault: false });
            }
        });

        return filtrosActivos;
    };

    const exportarPDF = () => {
        setLoadingPdf(true);
        monitoreoService.consultarInfo('dashboard/reporte/monitoreo').then(res => {
            const filtrosAplicados = obtenerFiltrosLegibles();
            const nombreEmpresa = empresaSel ? empresaSel.label : '';
            const nombreMatriz = matrizSel ? matrizSel.label : '';
            const info = {
                empresa: res.data.razon_social,
                logo: res.data.logo,
                nombre_usuario: res.data.nombre_usuario,
                fechaGeneracion: res.data.fecha_generacion,
                empresaSeleccionada: nombreEmpresa,
                matrizSeleccionada: nombreMatriz,
                filtrosAplicados: filtrosAplicados,
                totalFiltros: totalFiltrosActivos,
                coloresKpisPrincipales: kpiPrincipal.map(kpi => kpi?.color || '#ccc'),
                coloresKpisDemograficos: kpiDemografico.map(kpi => kpi?.color || '#ccc')
            };

            const images = capturarTodosLosGraficos();
            const docDefinition = getMonitoreoDashboardTemplate(images, info);

            pdfMake.createPdf(docDefinition).download(`Monitoreo_Dashboard_${new Date().toISOString().split('T')[0]}.pdf`);
        }).catch((error) => {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al cargar la información para el reporte.', life: 3000 });
        }).finally(() => {
            setLoadingPdf(false);
        });
    };

    const abrirDetalleKpi = (tipo, title) => {
        setKpiSidebar({ visible: true, tipo, title });
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog className="dialog-personalizado" />
            <Menu model={itemsMenu} popup ref={menuRef} id="popup_menu_alertas" />
            <Dialog header="Asignar Analista" visible={dialogAsignar} className="dialog-personalizado" style={{ width: '50vw' }} onHide={() => setDialogAsignar(false)} >
                <TablaDinamica modelo={AnalistaModel.model} estadoTabla={tablaEstadoAnalista} datos={tablaEstadoAnalista.data} totalRegistros={tablaEstadoAnalista.totalRecords} dataKey="id" stripedRows rowHover showGridlines={false} />
            </Dialog>
            <Sidebar visible={kpiSidebar.visible} position="right"
                onHide={() => {
                    setKpiSidebar({ visible: false, tipo: null, title: '' });
                    tablaEstado.setData([]);
                    tablaEstado.resetLazyParams();
                }}
                style={{ width: '50vw' }}>
                <div className="p-2">
                    <div className="flex align-items-center justify-content-between mb-3">
                        <div className="flex align-items-center gap-2">
                            {/* Cambiamos el icono dinámicamente si es "revisados" o "alertas" */}
                            <i className={`pi ${kpiSidebar.tipo === 'detalle_clientes_revisados' ? 'pi-check-circle text-green-500' : 'pi-exclamation-triangle text-orange-500'} text-xl`} />
                            <span className="font-bold text-lg text-gray-800">Detalles: {kpiSidebar.title}</span>
                        </div>
                    </div>
                    <p className="mb-4 text-sm text-gray-600 border-bottom-1 border-300 pb-2">
                        Listado de clientes asociados al indicador de <strong>{kpiSidebar.title}</strong>.
                    </p>
                    <TablaDinamica modelo={ClienteAlerta} estadoTabla={tablaEstado} datos={tablaEstado.data || []} totalRegistros={tablaEstado.totalRecords || 0} dataKey="id" size="small" />
                </div>
            </Sidebar>
            {tabActiveIndex === 1 && (
                <Button loading={loading || loadingPdf} icon="pi pi-file-pdf" onClick={exportarPDF} rounded tooltip="Exportar PDF" tooltipOptions={{ position: 'left' }}
                    className={`shadow-6 transition-all transition-duration-300 ${contextoListo ? 'fadein opacity-100 scalein' : 'opacity-0 pointer-events-none scaleout'}`}
                    style={{ position: 'fixed', bottom: '53px', right: '30px', zIndex: 999, width: '45px', height: '45px', backgroundColor: '#ef4444', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
            )}
            <Dialog visible={dialogReporte} header="Generar Reporte de Alertas" modal className="p-fluid modal-ssize dialog-personalizado"
                onHide={e => setDialogReporte(false)} style={{ maxWidth: '450px' }}>
                <div className="formgrid grid">
                    <div className="field col-6">
                        <label htmlFor="fechaInicio" className="font-bold block mb-2">
                            Fecha Inicio*
                        </label>
                        <Calendar id="fechaInicio" value={fechaInicioReporte} onChange={(e) => setFechaInicioReporte(e.value)} showIcon readOnlyInput maxDate={fechaFinReporte || new Date()} dateFormat="yy-mm-dd" />
                    </div>

                    <div className="field col-6">
                        <label htmlFor="fechaFin" className="font-bold block mb-2">
                            Fecha Fin*
                        </label>
                        <Calendar id="fechaFin" value={fechaFinReporte} onChange={(e) => setFechaFinReporte(e.value)} showIcon readOnlyInput minDate={fechaInicioReporte} maxDate={new Date()} dateFormat="yy-mm-dd" />
                    </div>
                    <div className="col-12">
                        <span style={{ color: 'var(--red-500)', fontSize: '11px', fontWeight: 'bold', display: 'block', textAlign: 'center' }}>
                            <i className="pi pi-info-circle mr-1"></i>
                            El rango máximo permitido es de {diasMaxDescargaReporte} días.
                        </span>
                    </div>
                    <br />
                    <div className="field col-12 flex justify-content-center gap-2 mt-3">
                        <Button label="Generar" icon={tipoReporte === 'pdf' ? "pi pi-file-pdf" : "pi pi-file-excel"} className={tipoReporte === 'pdf' ? "p-button-danger" : "p-button-success"} onClick={() => generarReporte(tipoReporte)} loading={tipoReporte === 'pdf' ? loadPdf : loadExcel} disabled={tipoReporte === 'pdf' ? loadExcel : loadPdf} raised />
                        <Button label="Limpiar" icon="pi pi-eraser" className="p-button-secondary p-button-text" onClick={() => limpiarReporte()} disabled={loadPdf || loadExcel} />
                    </div>
                </div>
            </Dialog>
            <div className="flex flex-column gap-3 p-2">
                <style>
                    {`
                        .kpi-dashboard-hover { transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s; }
                        .kpi-dashboard-hover:hover { transform: translateY(-4px); box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important; border-color: #94a3b8 !important; cursor: pointer; }
                    `}
                </style>
                <TabView className="mt-2 custom-tabview" activeIndex={tabActiveIndex} onTabChange={(e) => setTabActiveIndex(e.index)}>
                    <TabPanel header="Bandeja de Alertas" leftIcon="pi pi-list">
                        <div className="grid mb-1">
                            <div className="col-12">
                                <Card className="shadow-3 border-round-xl">
                                    <div className="flex flex-column md:flex-row justify-content-between align-items-start md:align-items-center mb-4 gap-3">
                                        <div>
                                            <span className="block text-xl font-bold text-900 mb-1">Bandeja de Gestión de Alertas</span>
                                            <span className="block text-500 text-sm">Monitoreo transaccional y comportamiento de riesgo</span>
                                        </div>
                                        <div className="flex gap-2">
                                            <Button onClick={() => { setDialogReporte(true); setTipoReporte('pdf') }} className="p-button-danger" title="Generar en formato PDF" icon="pi pi-file-pdf" tooltip="Generar Reporte PDF" tooltipOptions={{ position: 'bottom' }} loading={loadPdf} disabled={loadExcel} raised />
                                            <Button onClick={() => { setDialogReporte(true); setTipoReporte('xlsx') }} className="p-button-success" title="Generar en formato Excel" icon="pi pi-file-excel" tooltip="Generar Reporte Excel" tooltipOptions={{ position: 'bottom' }} loading={loadExcel} disabled={loadPdf} raised />
                                        </div>
                                    </div>
                                    <TablaDinamica modelo={AlertaModel.model} estadoTabla={tablaEstadoAlerta} datos={tablaEstadoAlerta.data} totalRegistros={tablaEstadoAlerta.totalRecords} dataKey="id" stripedRows rowHover showGridlines={false} acciones={columnaAcciones} />
                                </Card>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Dashboard e Indicadores" leftIcon="pi pi-chart-bar">
                        <div className="card p-3">
                            {/* CABECERA Y FILTROS INTEGRADOS (Fijo para evitar "saltos") */}
                            <div className="flex align-items-center justify-content-between mb-2 border-bottom-1 border-300 pb-2" style={{ minHeight: '52px' }}>
                                <div className="flex align-items-center gap-4">
                                    <h5 className="m-0 text-700 flex align-items-center">
                                        <i className="pi pi-filter mr-2 text-primary"></i>Parámetros y Filtros
                                    </h5>
                                    {/* Si matrizSel tiene value, es que a sido seleccionada */}
                                    {matrizSel?.value && (
                                        <div className="flex align-items-center bg-indigo-50 border-round-xl border-1 border-indigo-100 shadow-1 px-3 py-1 fadein animation-duration-300">
                                            <div className="flex align-items-center justify-content-center bg-indigo-100 border-circle w-2rem h-2rem mr-3">
                                                <i className="pi pi-briefcase text-indigo-600"></i>
                                            </div>
                                            <div className="flex flex-column mr-3">
                                                <span className="text-sm font-bold text-indigo-900" style={{ maxWidth: '300px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                    [{matrizSel.codigo}] {matrizSel.nombre}
                                                </span>
                                                <span className="text-xs text-indigo-600 font-medium flex align-items-center mt-1">
                                                    <i className="pi pi-calendar mr-1" style={{ fontSize: '0.65rem' }}></i>
                                                    {matrizSel.fecha_inicio} <span className="mx-1 text-400">|</span> {matrizSel.fecha_fin}
                                                </span>
                                            </div>
                                            <div className="border-left-1 border-indigo-200 h-2rem mx-2"></div>
                                            <Tag value={matrizSel.estado} severity={matrizSel.nemonico_estado === 'FINALIZADO' ? 'primary' : 'warning'} rounded className="ml-2 text-xs" />
                                        </div>
                                    )}
                                </div>
                                <div className="flex gap-2 align-items-center">
                                    {!contextoListo ? (
                                        <Skeleton width="190px" height="35px" />
                                    ) : (
                                        <>
                                            {totalFiltrosActivos > 0 && (
                                                <Button label="Limpiar Filtros" icon="pi pi-filter-slash" severity="secondary" size="small" badge={totalFiltrosActivos} badgeClassName="p-badge-secondary" onClick={resetearFiltros} text />
                                            )}
                                            <Button type="button" label="Más Filtros" icon="pi pi-sliders-h" size="small" onClick={() => setFiltrosVisibles(true)} />
                                        </>
                                    )}
                                </div>
                            </div>
                            {/* GRID DE FILTROS COMPACTO */}
                            <div ref={containerRef} className="flex flex-wrap gap-3 mb-3 bg-white border-round p-fluid w-full">
                                <AnimatePresence mode="popLayout">
                                    {filtrosTop.map((filtro) => (
                                        <motion.div key={filtro.id} layout="position" initial={{ opacity: 0, x: -10 }} animate={{ opacity: 1, x: 0, flex: "1 1 230px" }} exit={{ opacity: 0, scale: 0.95 }} transition={{ duration: 0.2 }} className="py-2" style={{ maxWidth: '480px', minWidth: '180px', boxSizing: 'border-box' }}>
                                            <label className="text-xs font-bold text-primary mb-1 block">
                                                {filtro.label}
                                            </label>
                                            {filtro.componente}
                                        </motion.div>
                                    ))}
                                </AnimatePresence>
                            </div>
                            {/* SIDEBAR DE FILTROS AVANZADOS */}
                            <Sidebar visible={filtrosVisibles} position="right" onHide={() => setFiltrosVisibles(false)} style={{ width: '350px' }}>
                                <h3 className="mt-0 mb-2">Filtros Avanzados</h3>
                                <p className="text-500 text-sm mb-4 border-bottom-1 border-300 pb-3">Refine su búsqueda utilizando los siguientes parámetros.</p>
                                <div className="flex flex-column gap-3 p-fluid">
                                    {filtrosSidebar.length > 0 ? (
                                        filtrosSidebar.map((filtro) => (
                                            <div key={filtro.id} className="fadein animation-duration-400">
                                                <label className="text-sm text-600 block mb-1">{filtro.label}</label>
                                                {filtro.componente}
                                            </div>
                                        ))
                                    ) : (
                                        <p className="text-500 text-sm italic">Todos los filtros están visibles en la barra superior.</p>
                                    )}
                                    <div className="pb-5"></div>
                                </div>
                            </Sidebar>
                            <div className="flex flex-column gap-3 mt-2 fadein animation-duration-500">
                                {/* SECCIÓN 1: Comportamiento Perfil Transaccional */}
                                <div className="surface-ground p-2 border-round">
                                    <h6 className="flex align-items-center gap-2 mt-0 mb-3 text-700 text-sm uppercase">
                                        <i className="pi pi-shield text-red-600"></i> Comportamiento Perfil Transaccional
                                    </h6>
                                    {/* Fila 1: 5 KPIs Principales */}
                                    <div className="grid">
                                        {(!contextoListo ? Array.from({ length: 5 }) : kpiPrincipal).map((item, i) => (
                                            <div key={`kpi-fila1-${i}`} className="col-12 sm:col-6 xl:col">
                                                <div className={`bg-white p-2 border-round shadow-1 border-left-2 flex flex-column h-full ${item?.tipo ? 'kpi-dashboard-hover cursor-pointer' : ''}`}
                                                    style={{ minHeight: '110px', borderLeftColor: item?.color || '#ccc' }}
                                                    onClick={() => contextoListo && item?.tipo && abrirDetalleKpi(item.tipo, item.title)}>
                                                    {!contextoListo ? <Skeleton width="100%" height="100%" /> : (
                                                        <div style={{ flex: 1, position: 'relative', minHeight: 0, minWidth: 0 }}>
                                                            <ApacheEchart chartOpciones={item.options} showToolbar={false} isLoading={loading} ref={setChartRef(`kpi-riesgo-${i}`)} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    {/* Fila 2: 3 KPIs Demográficos / Secundarios Centrados */}
                                    <div className="grid justify-content-center mt-2">
                                        {(!contextoListo ? Array.from({ length: 3 }) : kpiDemografico).map((item, i) => (
                                            <div key={`kpi-fila2-${i}`} className="col-12 sm:col-6 md:col-4 xl:col-3">
                                                <div className={`bg-white p-2 border-round shadow-1 border-left-2 flex flex-column h-full ${item?.tipo ? 'kpi-dashboard-hover cursor-pointer' : ''}`}
                                                    style={{ minHeight: '110px', borderLeftColor: item?.color || '#ccc' }}
                                                // onClick={() => contextoListo && item?.tipo && abrirDetalleKpi(item.tipo, item.title)}
                                                >
                                                    {!contextoListo ? <Skeleton width="100%" height="100%" /> : (
                                                        <div style={{ flex: 1, position: 'relative', minHeight: 0, minWidth: 0 }}>
                                                            <ApacheEchart chartOpciones={item.options} showToolbar={false} isLoading={loading} ref={setChartRef(`kpi-centrado-${i}`)} />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                {/* SECCIÓN 2: Otros Indicadores */}
                                <div className="surface-ground p-2 border-round">
                                    <h6 className="flex align-items-center gap-2 mt-0 mb-3 text-700 text-sm uppercase">
                                        <i className="pi pi-chart-bar text-blue-600"></i> Otros Indicadores
                                    </h6>
                                    {/* Fila 1: Choropleth Map (Izquierda) y Bar Chart (Derecha) */}
                                    <div className="grid">
                                        <div className="col-12 lg:col-6">
                                            <div className="bg-white p-2 border-round shadow-1 flex flex-column" style={{ height: '350px' }}>
                                                {!contextoListo ? <Skeleton width="100%" height="100%" /> : (
                                                    <div style={{ flex: 1, position: 'relative', minHeight: 0, minWidth: 0 }}>
                                                        <ApacheEchart chartOpciones={mapChartOptions} showToolbar={false} isLoading={loading} ref={setChartRef('mapa-principal')} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-12 lg:col-6">
                                            <div className="bg-white p-2 border-round shadow-1 flex flex-column" style={{ height: '350px' }}>
                                                {!contextoListo ? <Skeleton width="100%" height="100%" /> : (
                                                    <div style={{ flex: 1, position: 'relative', minHeight: 0, minWidth: 0 }}>
                                                        <ApacheEchart chartOpciones={barChartOptions} showToolbar={false} isLoading={loading} ref={setChartRef('barras-principal')} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    {/* Fila 2: Pie Chart (Centrado) */}
                                    <div className="grid justify-content-center mt-2">
                                        <div className="col-12 lg:col-6">
                                            <div className="bg-white p-2 border-round shadow-1 flex flex-column" style={{ height: '350px' }}>
                                                {!contextoListo ? <Skeleton width="100%" height="100%" /> : (
                                                    <div style={{ flex: 1, position: 'relative', minHeight: 0, minWidth: 0 }}>
                                                        <ApacheEchart chartOpciones={pieChartOptions} showToolbar={false} isLoading={loading} ref={setChartRef('pie-chart')} />
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </TabPanel>
                </TabView>
            </div>
        </>
    );
};
